module.exports = __webpack_public_path__ + "static/img/features.52ed13c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-TW/features.png
// module id = QJJR
// module chunks = 1